import { Icon, IconProps } from './Icon';

export type AudioAssetProps = IconProps;

export const AudioAsset = (props: AudioAssetProps) => (
  <Icon width="36px" height="36px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
    <rect width="36" height="36" rx="8" fill="currentcolor"/><rect width="36" height="36" rx="8" fill="currentcolor" fillOpacity=".2"/><path d="M15 24V12.355c0-.481 0-.722.088-.917a1 1 0 0 1 .358-.424c.178-.118.416-.158.891-.237l8.8-1.467c.64-.106.961-.16 1.211-.067a1 1 0 0 1 .52.44c.132.231.132.556.132 1.206V22m-12 2a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm12-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" stroke="currentcolor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </Icon>
)
